/* KOR-E designed-categories carousel — extracted from sections/kore-designed-categories.liquid
   (Batch AR, 2026-07-29). The section renders twice on the homepage, so this was ~8KB of
   duplicated, unminified inline script in the document. Per-instance Liquid values arrive
   through the window.__koreDC bootstrap queue; replacing the queue with a {push:init} shim
   means sections added later by the Theme Editor initialise immediately. */
(function () {
  function init(cfg) {

  'use strict';
  var SID = cfg.sid;
  var carousel = document.getElementById('kdc-carousel-' + SID);
  var track    = document.getElementById('kdc-track-'   + SID);
  if (!carousel || !track) return;

  /* JS-gated card-image loading is handled by the shared utility
     assets/kore-gated-images.js (img[data-kore-gate-src]). It also keeps the
     CSS-hidden device-duplicate instance of this section from downloading
     anything: display:none never intersects. */

  /* Initial scroll position */
  requestAnimationFrame(function () {
    if (window.innerWidth >= 750) {
      /* Desktop: row-reverse + LTR scroll — flush right so first category shows */
      track.scrollLeft = track.scrollWidth;
    } else {
      /* Mobile: direction:rtl on track makes scrollLeft=0 the right edge
         (first category visible). Set explicitly to override scroll restoration. */
      track.scrollLeft = 0;
    }
  });

  /* Show/hide arrows based on scroll position */
  var prevBtn = carousel.querySelector('.kdc__arrow--prev');
  var nextBtn = carousel.querySelector('.kdc__arrow--next');

  function updateArrows() {
    if (!prevBtn || !nextBtn) return;
    var atStart = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    var atEnd   = track.scrollLeft <= 2;
    prevBtn.style.visibility = atStart ? 'hidden' : 'visible';
    nextBtn.style.visibility = atEnd   ? 'hidden' : 'visible';
  }

  updateArrows();
  track.addEventListener('scroll', updateArrows, { passive: true });

  /* Mobile two-direction arrows */
  var mobLeft  = document.getElementById('kdc-mob-left-'  + SID);
  var mobRight = document.getElementById('kdc-mob-right-' + SID);

  function getMobCardW() {
    var card = track.querySelector('.kdc__card');
    var gap  = parseFloat(getComputedStyle(track).gap) || cfg.gap;
    return card ? card.offsetWidth + gap : 200;
  }

  function updateMobArrows() {
    if (window.innerWidth >= 750) return;
    /* RTL scroll (direction:rtl on track):
       scrollLeft=0 at the right edge (first category visible).
       Going left makes scrollLeft negative in Chrome/Safari, varies in Firefox.
       Math.abs normalises across all browsers. */
    var maxScroll = track.scrollWidth - track.clientWidth;
    var scrolled  = Math.abs(track.scrollLeft);
    var atStart   = scrolled <= 4;              /* at rightmost = first category */
    var atEnd     = scrolled >= maxScroll - 4;  /* at leftmost  = last category  */
    if (mobLeft)  mobLeft.classList.toggle('kdc__mob-btn--hidden',  atEnd);
    if (mobRight) mobRight.classList.toggle('kdc__mob-btn--hidden', atStart);
  }

  if (mobLeft || mobRight) {
    updateMobArrows();
    track.addEventListener('scroll',               updateMobArrows, { passive: true });
    window.addEventListener('resize',              updateMobArrows, { passive: true });
    document.addEventListener('shopify:section:load', updateMobArrows);
  }

  if (mobLeft) {
    mobLeft.addEventListener('click', function () {
      /* Scroll physically left → reveals more categories (RTL "forward") */
      track.scrollBy({ left: -getMobCardW(), behavior: 'smooth' });
    });
  }
  if (mobRight) {
    mobRight.addEventListener('click', function () {
      /* Scroll physically right → back toward first category (RTL "back") */
      track.scrollBy({ left: getMobCardW(), behavior: 'smooth' });
    });
  }

  /* Arrow click scroll */
  carousel.querySelectorAll('.kdc__arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir   = btn.dataset.dir;
      var card  = track.querySelector('.kdc__card');
      var gap   = parseFloat(getComputedStyle(track).gap) || cfg.gap;
      var cardW = card ? card.offsetWidth + gap : 220;
      /* row-reverse: next = physically left (−), prev = physically right (+) */
      track.scrollBy({ left: dir === 'next' ? -cardW : cardW, behavior: 'smooth' });
    });
  });


  }
  function boot() { var q = window.__koreDC || []; (q.forEach ? q : []).forEach(init); window.__koreDC = { push: init }; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
